import { useEffect, useState } from 'react'

const QUERY = '(prefers-reduced-motion: reduce)'

function readPref(): boolean {
  if (typeof window === 'undefined' || typeof window.matchMedia !== 'function') return false
  return Boolean(window.matchMedia(QUERY).matches)
}

/**
 * Live `prefers-reduced-motion: reduce` flag. Re-renders when the OS
 * preference changes. Returns `false` in SSR / non-matchMedia environments.
 *
 * The single source of truth for motion gating — replaces the ad-hoc
 * `prefersReducedMotion()` copies scattered across the apps.
 */
export function useReducedMotion(): boolean {
  const [reduced, setReduced] = useState(readPref)

  useEffect(() => {
    if (typeof window === 'undefined' || typeof window.matchMedia !== 'function') return
    const mq = window.matchMedia(QUERY)
    const onChange = () => setReduced(mq.matches)
    onChange() // sync in case it changed between first render and effect
    mq.addEventListener?.('change', onChange)
    return () => mq.removeEventListener?.('change', onChange)
  }, [])

  return reduced
}
